import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const VideosPage = lazy(() => import('../pages/videos/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const AdoptPage = lazy(() => import('../pages/adopt/page'));
const AdoptCatDetailPage = lazy(() => import('../pages/adopt/cat/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogPostPage = lazy(() => import('../pages/blog/post/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const WildcatsPage = lazy(() => import('../pages/wildcats/page'));
const BreedDetailPage = lazy(() => import('../pages/breeds/page'));
const CatCareGuidePage = lazy(() => import('../pages/cat-care-guide/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const TermsPage = lazy(() => import('../pages/legal/terms/page'));
const PrivacyPage = lazy(() => import('../pages/legal/privacy/page'));
const CookiesPage = lazy(() => import('../pages/legal/cookies/page'));
const MemesPage = lazy(() => import('../pages/memes/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/videos',
    element: <VideosPage />,
  },
  {
    path: '/shop',
    element: <ShopPage />,
  },
  {
    path: '/shop/:handle',
    lazy: async () => {
      const { default: ProductDetailPage } = await import('@/pages/shop/product/page');
      return { Component: ProductDetailPage };
    },
  },
  {
    path: '/adopt',
    element: <AdoptPage />,
  },
  {
    path: '/adopt/cat/:catId',
    element: <AdoptCatDetailPage />,
  },
  {
    path: '/breeds/:breedSlug',
    element: <BreedDetailPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogPostPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/wildcats',
    element: <WildcatsPage />,
  },
  {
    path: '/cat-care-guide',
    element: <CatCareGuidePage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/memes',
    element: <MemesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;